<template>
  <!--权限首页  -->
  <div class="managerIndex">
    <el-card>
      <el-button type="primary" @click="handleAdd">添加</el-button>
    </el-card>

    <el-card>
      <el-table
        border
        ref="multipleTable"
        style="width: 100%; flex: auto"
        tooltip-effect="light"
        :data="listData"
        @selection-change="handleSelectionChange"
        :header-cell-style="getRowClass"
      >
        <el-table-column prop="phone" label="手机号"></el-table-column>
        <el-table-column prop="email" label="邮箱"></el-table-column>
        <el-table-column prop="account" label="账号"></el-table-column>
      
        <el-table-column prop="roleId" label="角色">
          <template slot-scope="{row}">
            <!-- <el-select v-model="row.roleId" placeholder="请选择">
              <el-option
                v-for="item in roleList"
                :key="item.roleId"
                :label="item.roleName"
                :value="item.roleId"
              ></el-option>
            </el-select> -->
            <div v-for="(item,index) in roleList" :key="index">
              <span v-if="item.roleId == row.roleId">{{item.roleName}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          class-name="small-padding fixed-width"
          label="操作"
          width="200px"
        >
          <template slot-scope="{row,$index}">
            <el-button type="primary" @click="messageDel(row.id)">删除</el-button>
            <el-button type="primary" @click="messageEdit(row.id,$index)">修改</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-row style="width:auto;marginRight:50px;marginTop:20px;">
        <el-pagination
          :current-page="currentPage"
          :page-size="pagesize"
          :page-sizes="[5,10,15]"
          :total="totalCount"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        ></el-pagination>
      </el-row>
    </el-card>
    <!-- 权限增加弹框 -->
    <a-modal
      title="权限增加"
      :visible="addOpen"
      @ok="handleOk('ruleForm')"
      @cancel="handleCancel"
      ok-text="保存"
      cancel-text="取消"
      :footer="null"
    >
      <el-form
        label-width="120px"
        size="small"
        :inline="true"
        :rules="rules"
        :model="messData"
        ref="ruleForms"
        :label-position="labelPosition"
        id="messAdd"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="账号" prop="account">
              <el-input placeholder="请输入内容" v-model="messData.account"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="邮箱" prop="email">
              <el-input placeholder="请输入内容" v-model="messData.email"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="手机号" prop="phone">
              <el-input placeholder="请输入内容" v-model="messData.phone"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="密码" prop="pwd">
              <el-input placeholder="请输入内容" v-model="messData.pwd"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="角色" >
               <el-select v-model="messData.roleId" placeholder="请选择">
              <el-option
                v-for="item in roleList"
                :key="item.roleId"
                :label="item.roleName"
                :value="item.roleId"
              ></el-option>
            </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-button type="primary" @click="messageAdd('ruleForms')" style="margin:20px 380px;">保存</el-button>
        </el-row>
      </el-form>
    </a-modal>
    <!-- 权限修改 -->
    <a-modal
      title="nms用户修改"
      :visible="editOpen"
      @ok="handleOk('ruleForm')"
      @cancel="handleCancel"
      ok-text="保存"
      cancel-text="取消"
      :footer="null"
    >
      <el-form
        label-width="120px"
        size="small"
        :inline="true"
        :rules="ruleEdit"
        :model="editList"
        ref="ruleForm"
        :label-position="labelPosition"
        id="delmess"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="账号" >
              <el-input placeholder="请输入内容" v-model="editList.account"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="邮箱">
              <el-input placeholder="请输入内容" v-model="editList.email"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="手机号" prop="phone">
              <el-input placeholder="请输入内容" v-model="editList.phone"></el-input>
            </el-form-item>
          </el-col>

          <!-- <el-col :span="12">
            <el-form-item label="密码" prop="pwd">
              <el-input placeholder="请输入内容" v-model="editList.pwd"></el-input>
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item label="角色" prop="roleId">
              <el-select v-model="editList.roleId" placeholder="请选择">
              <el-option
                v-for="item in roleList"
                :key="item.roleId"
                :label="item.roleName"
                :value="item.roleId"
              ></el-option>
            </el-select>
            </el-form-item>
          </el-col>
        </el-row>
       
        <el-row>
          <el-button type="primary" @click="messViaEdit('ruleForm')" style="margin:20px 380px;">保存</el-button>
        </el-row>
      </el-form>
    </a-modal>
  </div>
</template>
<script>
export default {
  data() {
    let checkPhone = (rule, value, callback) => {
      let reg = /^1[345789]\d{9}$/;
      if (!reg.test(value)) {
        callback(new Error("请输入11位手机号"));
      } else {
        callback();
      }
    };
    var checkEmail = (rule, value, callback) => {
      const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
      if (!value) {
        return callback(new Error("邮箱不能为空"));
      }
      setTimeout(() => {
        if (mailReg.test(value)) {
          callback();
        } else {
          callback(new Error("请输入正确的邮箱格式"));
        }
      }, 100);
    };
 

    return {
      labelPosition: "top", //form样式
      addOpen: false, //权限增加弹框
      editOpen: false, //权限修改弹框
      currentPage: 1, //初始页
      pagesize: 10, //每页数据
      totalCount: 0, //分页数量展示
      listData: [], //权限数据
      //权限增加数据
      messData: {
        account: "", //账号
        email: "", //邮箱
        phone: "", //手机号
        pwd: "", //密码
        roleId: "" //角色
      },
      //权限修改
      messEdit: {
        account: "", //账号
        email: "", //邮箱
        phone: "", //手机号
        pwd: "", //密码
        roleId: "" //角色
      },
      editList:'',//编辑数据
      //添加校验：
      rules: {
        account: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        email: [{ validator: checkEmail, trigger: "blur" }],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            type: "number",
            validator: checkPhone,
            message: "请输入11位有效手机号号码",
            trigger: ["blur", "change"]
          }
        ],
        pwd: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        roleId: [{ required: true, message: "内容不能为空", trigger: "blur" },
         ]
      },
      //修改校验：
      ruleEdit: {
        account: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        email: [{ validator: checkEmail, trigger: "blur" }],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            type: "number",
            validator: checkPhone,
            message: "请输入11位有效手机号号码",
            trigger: ["blur", "change"]
          }
        ],
        pwd: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        roleId: [{ required: true, message: "内容不能为空", trigger: "blur" }]
      },
      editId: "", //修改id
      roleList: "" //角色列表
    };
  },
  methods: {
    //头部样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f5f7fa;color:#000;width:100%";
      } else {
        return "";
      }
    },
    //获取数据
    init() {
      this.postAxios("/manager/list", {
        pageNum: this.currentPage,
        pageSize: 10
      }).then(res => {
        if (res.success == true) {
          this.listData = res.content;
           this.totalCount = res.totalCount;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push('/')
        }else if(res.success==false){
          this.$message.error(res.message);
        }
      });
    },
    //分页
    handleCurrentChange: function(currentPage) {
      this.currentPage = currentPage;
      this.init();
      // console.log(this.currentPage); //点击第几页
    },
    //分页：
    handleSizeChange: function(size) {
      this.pagesize = size;
      this.init();
      // console.log(this.pagesize); //每页下拉显示数据
    },
    //分页
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //权限增加：
    handleAdd() {
      // this.$router.push({path:'/ManagerAdd'})
      this.addOpen = true;
    },
    //权限弹框关闭
    handleCancel() {
      this.addOpen = false;
      this.editOpen = false;
      this.$refs.ruleForms.resetFields();
      this.$refs.ruleForm.resetFields();
      
    },
    //权限增加弹框保存
    messageAdd(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.postAxios("/manager/insert", {
            account: this.messData.account, //账号
            email: this.messData.email, //邮箱
            phone: this.messData.phone, //手机号
            pwd: this.messData.pwd, //密码
            roleId: this.messData.roleId //角色
          }).then(res => {
            if (res.success == true) {
              this.$message.success("新增成功");
              this.addOpen = false;
              this.init();
              document.getElementById("messAdd").reset();
            } else if (res.success == false) {
              this.$message.error(res.message);
            } else if (!res.success && res.statusCode == "401") {
              this.$message.error(res.message);
              this.$router.push('/')
            }
          });
        }
      });
    },
    //权限删除
    messageDel(id) {
      this.getAxios("/manager/delete", {
        managerId: id
      }).then(res => {
        if (res.success == true) {
          this.$message.success("删除成功");
          this.init();
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (!res.success && res.statusCode == "401") {
         this.$message.error(res.message);
         this.$router.push('/')
        }
      });
    },
    //权限修改
    messageEdit(id,ind) {
      this.editId = id;
      this.editOpen = true;
      this.editList = this.listData[ind]
    },
    //权限修改保存
    messViaEdit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.postAxios("/manager/update", {
            id: this.editId,
            account: this.editList.account, //账号
            email: this.editList.email, //邮箱
            phone: this.editList.phone, //手机号
            // pwd: this.editList.pwd, //密码
            roleId: this.editList.roleId //角色
          }).then(res => {
            if (res.success == true) {
              this.$message.success("修改成功");
              this.editOpen = false;
              this.init();
            //   document.getElementById("delmess").reset();
            } else if (res.success == false) {
              this.$message.error(res.message);
            } else if (!res.success && res.statusCode == "401") {
              this.$message.error(res.message);
              this.$router.push('/')
            }
          });
        }
      });
    },
    //角色数据：
    getRole() {
      this.getAxios("/role/list", {}).then(res => {
        if (res.success == true) {
          this.roleList = res.content;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push('/')
        }else if(res.success==false){
          this.$message.error(res.message);
        }
      });
    }
  },
  created() {
    this.init(); //获取数据
    this.getRole(); //角色数据
  }
};
</script>
<style scoped lang="less">
.managerIndex {
  width: 100%;
  height: 100%;
  .el-card {
    width: 95%;
    margin: 20px auto;
  }
  /deep/ .el-table {
    width: 100%;
  }
  /deep/ .ant-modal-content {
    position: relative;
    background-color: #fff;
    background-clip: padding-box;
    border: 0;
    border-radius: 4px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    pointer-events: auto;
    width: 800px !important;
    height: 500px !important;
  }
   /deep/ .el-button--primary {
          color: #fff;
          background-color: #409eff;
          border-color: #409eff;
          width: 100px;
          margin-top: 10px;
          margin-left: 10px;
        }
}
</style>